var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "#F95C66",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 5.0013V16.668C15.8346 17.11 15.659 17.5339 15.3465 17.8465C15.0339 18.159 14.61 18.3346 14.168 18.3346H5.83464C5.39261 18.3346 4.96868 18.159 4.65612 17.8465C4.34356 17.5339 4.16797 17.11 4.16797 16.668V5.0013M6.66797 5.0013V3.33464C6.66797 2.89261 6.84356 2.46868 7.15612 2.15612C7.46868 1.84356 7.89261 1.66797 8.33464 1.66797H11.668C12.11 1.66797 12.5339 1.84356 12.8465 2.15612C13.159 2.46868 13.3346 2.89261 13.3346 3.33464V5.0013",
    stroke: "#F95C66",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 9.16797V14.168",
    stroke: "#F95C66",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 9.16797V14.168",
    stroke: "#F95C66",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.8d492181582349bc45db58ec5d798011.svg";
export { ForwardRef as ReactComponent };